import { render, staticRenderFns } from "./odd.vue?vue&type=template&id=5373d9a1&scoped=true"
import script from "./odd.vue?vue&type=script&lang=js"
export * from "./odd.vue?vue&type=script&lang=js"
import style0 from "./odd.vue?vue&type=style&index=0&id=5373d9a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373d9a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5373d9a1')) {
      api.createRecord('5373d9a1', component.options)
    } else {
      api.reload('5373d9a1', component.options)
    }
    module.hot.accept("./odd.vue?vue&type=template&id=5373d9a1&scoped=true", function () {
      api.rerender('5373d9a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Report/TimeLimitForSigning/odd.vue"
export default component.exports